import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Tooltip from '@material-ui/core/Tooltip';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import randomColor from 'randomcolor';

import _ from 'lodash';

import Slider from 'react-slick';

import PieChartAnalytics from '../../../Analytics/components/PieChartAnalytics';

const styles = {
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  containerAnalyticsDialog: {
    padding: '40px',
  },
};

class AnalyticsComponent extends Component {
  constructor(props) {
    super(props);

    this.sendGraphToUser = this.sendGraphToUser.bind(this);
  }

  handleClose = () => {
    this.props.onClose();
  };

  async sendGraphToUser() {
    let arrayObjChart = [];
    let index = 0;

    for (let question of this.props.questionsAnalytics) {
      const ref = this.graphRef[index];
      if (ref && ref.current) {
        const chartResponsive = ref.current.querySelector('#chartResponsive');
        const totalCorrectAnswers = _.get(question, 'totalCorrectAnswers', 0);
        const totalWrongAnswers = _.get(question, 'totalWrongAnswers', 0);
        const total = totalCorrectAnswers + totalWrongAnswers;

        if (chartResponsive && chartResponsive.firstElementChild) {
          const chartChild = chartResponsive.firstElementChild.outerHTML;

          let options = question.options.map((option, indexOpt) => {
            let color = randomColor({ seed: indexOpt * 20 });
            if (option.index === -1) {
              color = '#d9dbde';
            }

            let percentage = 0;
            if (total) {
              percentage = (100 * option.total) / total;
            }
            return {
              index: option.index,
              title: option.title,
              totalPercentage: percentage,
              color,
            };
          });

          let out = {
            title: question.questionTitle,
            html: chartChild,
            options,
          };

          arrayObjChart.push(out);
        }
      }
      index++;
    }

    return this.props.sendStatistics(arrayObjChart);
  }

  render() {
    const {
      classes,
      access,
      open,
      interactionTitle,
      questionsAnalytics,
      filterOption,
    } = this.props;

    const settings = {
      dots: true,
    };

    let defaultQuestionWithData;

    this.graphRef = [];
    if (this.props.questionsAnalytics) {
      this.props.questionsAnalytics.forEach((question, index) => {
        this.graphRef[index] = React.createRef();
      });
      defaultQuestionWithData =
        questionsAnalytics.filter(
          el => el.type === 'defaultQuestion' && el.questionHasData === true
        ).length > 0;
    }

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        className={classes.preview}
      >
        <DialogTitle id="simple-dialog-title" className={classes.dialogTitle}>
          {interactionTitle === null ? '' : interactionTitle}
        </DialogTitle>
        <DialogContent className={classes.containerAnalyticsDialog}>
          <Slider {...settings}>
            {defaultQuestionWithData ? (
              questionsAnalytics.map((question, index) => {
                const pieChart = (
                  <div key={index}>
                    <div ref={this.graphRef[index]}>
                      <PieChartAnalytics
                        question={question}
                        preview={true}
                        filter={filterOption}
                      />
                    </div>
                  </div>
                );
                return question.questionHasData &&
                  question.type === 'defaultQuestion'
                  ? pieChart
                  : null;
              })
            ) : (
              <div>No records to display</div>
            )}
          </Slider>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Close
          </Button>
          {access === 'host' &&
            defaultQuestionWithData && (
              <Tooltip title="Click to send this data" placement="top">
                <Button
                  onClick={this.sendGraphToUser}
                  color="primary"
                  autoFocus
                >
                  Send
                </Button>
              </Tooltip>
            )}
        </DialogActions>
      </Dialog>
    );
  }
}

const DialogAnalytics = withStyles(styles)(AnalyticsComponent);
// const RenderTooltip = withStyles(styles)(TooltipComponent);

export { DialogAnalytics };
